import * as React from "react"

export default function Search() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={33} height={34} fill="none">
            <path
                stroke="#87B44D"
                strokeLinecap="square"
                strokeWidth={3}
                d="M10.976 22.464c4.688 4.688 12.289 4.688 16.977 0 4.687-4.688 4.687-12.288 0-16.976C23.265.8 15.664.8 10.976 5.488c-4.688 4.688-4.688 12.288 0 16.976Zm0 0-8.488 8.489"
            />
        </svg>
    )
}
